import { EventBus } from 'vtils'

export const stationBus = new EventBus<{
  select: (item: any) => any
}>()
